import type { DashboardSummaryResponse } from "@nlc/shared-types";

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useDashboardSummary(): UseQueryResult<DashboardSummaryResponse> {
  return useQuery({
    queryFn: () =>
      apiClient
        .url("/dashboard/summary")
        .get()
        .json<DashboardSummaryResponse>(),
    queryKey: ["dashboard", "summary"],
  });
}
